import { RootState } from 'editor/src/store/index';

const getQuantitySavingsQuote = (state: RootState) => state.quantitySavings.quote;

export default getQuantitySavingsQuote;
